/*
 * Copyright (c) 2026, King Living
 * Shared helpers for login authentication errors.
 */

/**
 * @param {unknown} error
 * @returns {boolean}
 */
export function isLoginUnauthorizedError(error) {
  const status = error?.response?.status;
  const message = String(error?.message || '');

  return (
    status === 401 ||
    /Unauthorized/i.test(message) ||
    message === '401'
  );
}
